export default "__VITE_ASSET__CJ6QH89M__"